const JWT_TEMPLATE = 'chancey-api';

export type ClerkGetToken = (options?: {
  template?: string;
  skipCache?: boolean;
}) => Promise<string | null>;

export async function getChanceyApiToken(
  getToken: ClerkGetToken,
  options: { skipCache?: boolean } = {}
): Promise<string | null> {
  try {
    const templateToken = await getToken({
      template: JWT_TEMPLATE,
      skipCache: options.skipCache,
    });
    if (templateToken) return templateToken;
  } catch {
    // Fall through to the default Clerk session token. Production can still
    // authenticate even if the custom JWT template is temporarily missing.
  }

  try {
    return await getToken({ skipCache: options.skipCache });
  } catch {
    return null;
  }
}
